interface SidebarToggleIconProps {
  open: boolean;
  className?: string;
}

export function SidebarToggleIcon({
  open,
  className,
}: SidebarToggleIconProps) {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.6}
      stroke="currentColor"
      aria-hidden="true"
    >
      <rect x="3.25" y="4.5" width="17.5" height="15" rx="2.5" />
      <path
        strokeLinecap="round"
        d={open ? "M15.75 5.5v13" : "M8.25 5.5v13"}
      />
    </svg>
  );
}
